/**
 * Wrapper for a settings section that persists the moment it changes (S24
 * review): it SAYS so permanently, and flips to a transient "Saved" line
 * after each commit. Without this, DashboardSettingsDialog's mixed commit
 * model was invisible — a user clicking the footer's close button believed
 * their parameter/playlist edits had been reverted.
 */
import type { ReactNode } from 'react';
import { Check } from 'lucide-react';

export const SAVED_FLASH_MS = 2200;

export function InstantSaveSection({
  saved,
  testId,
  children,
}: {
  saved: boolean;
  testId: string;
  children: ReactNode;
}) {
  return (
    <div className="rounded-md border border-border px-3 py-2.5">
      {children}
      <p
        className={`mt-2 flex items-center gap-1 text-[11px] ${
          saved ? 'text-emerald-600 dark:text-emerald-400' : 'text-muted-foreground'
        }`}
        aria-live="polite"
        data-testid={testId}
        data-saved={saved ? 'true' : undefined}
      >
        {saved ? (
          <>
            <Check className="h-3 w-3" aria-hidden />
            Saved
          </>
        ) : (
          'Saves immediately'
        )}
      </p>
    </div>
  );
}
